<template>
  <van-row
    class="organization-item"
    @click="chooseOrgHandler"
  >
    <van-col class="avatar">
      <lazy-component class="lazy-component">
        <van-image
          round
          width="100%"
          height="100%"
          :src="item.avatar"
        />
      </lazy-component>
    </van-col>
    <van-col class="info">
      <p class="name">{{ item.name }}</p>
      <p class="label">
        <van-rate v-model="item.star" readonly />
      </p>
    </van-col>
  </van-row>
</template>

<script>
export default {
  name: 'OrganizationItem',
  props: {
    item: {
      type: Object,
      default: () => {},
      required: true
    }
  },
  methods: {
    chooseOrgHandler () {
      this.$router.push({
        name: 'login',
        params: {
          organizationId: this.item.id
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.organization-item {
  @include wh(100%, 78px);
  padding: 4px;
  background-size: contain;
  background-position: right top;
  background-repeat: no-repeat;
  .avatar {
      @include wh(70px, 70px);
      .lazy-component {
        @include wh(100%, 100%);
      }
    }
  .info {
    height: 100%;
    padding: 14px 16px;
    .name {
      @include sc($font-size-xlg, $color-text-heavy);
      @include lw(18px, 500);
      margin-bottom: 12px;
    }
    .label {
      @include sc($font-size-base, $color-text-light);
    }
  }
}
</style>
